import { Route } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { DashboardLayoutComponent } from './core/components/dashboard-layout/dashboard-layout.component';
import { AccountComponent } from './features/accounts/pages/account/account.component';
import { StatisticsComponent } from './features/statistics/pages/statistics/statistics.component';
import { WorkersComponent } from './features/workers/pages/workers/workers.component';
import { PayoutsComponent } from './features/payouts/pages/payouts/payouts.component';
import { RewardsComponent } from './features/rewards/pages/rewards/rewards.component';
import { PageNotFoundComponent } from '@wm-libs/core';
import { environment } from '../environments/environment';
import { SettingsComponent } from './features/settings/pages/settings/settings.component';
import { AccessTokenComponent } from './features/access-token/pages/access-token/access-token.component';

export const appRoutes: Route[] = [
  {
    path: 'accessToken/:token',
    component: AccessTokenComponent,
  },
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      { path: 'account', component: AccountComponent },
      { path: 'statistics', component: StatisticsComponent },
      { path: 'workers', component: WorkersComponent },
      { path: 'payouts', component: PayoutsComponent },
      { path: 'rewards', component: RewardsComponent },
      { path: 'settings', component: SettingsComponent },
      { path: '', redirectTo: 'statistics', pathMatch: 'full' },
    ],
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
    data: { app: 'wm-tech-pool', env: environment },
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
    pathMatch: 'full',
  },
];
